(function () {
  class CustomSelect extends HTMLElement {
    static get observedAttributes() {
      return ["value"];
    }
    constructor() {
      super();
      this.attachShadow({ mode: "open" });
      this.selectedValue = "";
      this.placeholder = this.dataset?.placeholder;
      const wrapper = document.createElement("div");
      wrapper.setAttribute("class", "custom-select-wrapper");

      const styles = `
               :host(*) {
              box-sizing: border-box;
              }
              :host([open]) .custom-select-options {
              display: block;
              }
                :host([open]) .arrow {
                transform: rotate(180deg);
                }

.arrow {
transition: transform 0.25s ease;
}
              .custom-select-wrapper {
              position: relative;
              }
  
              .custom-select {
              display: flex;
              align-items: center;
              justify-content: space-between;
              background-color: transparent;
              padding: 10px;
              border-radius: 8px;
              cursor: pointer;
              position: relative;
              color: inherit;
              }
  
              .custom-select-options {
              padding: 12px 0;
              display: none;
              position: absolute;
              top: 46px;
              left: -1px;
              width: 100%;
              background-color: #fff;
              border: 1px solid var(--main-color, #2f2f2f);
              border-radius: 5px;
              z-index: 30;
              max-height: 200px;
              overflow-y: auto;
              color: #000;
              cursor: pointer;
              }
  
              ::slotted(choice) {
              display: block;
              transition: background-color 0.1s ease;
              padding: 0 12px !important;
              font-size: 14px;
              }
  
              ::slotted(choice:hover) {
              background-color: #e5eacd;
              }
              ::slotted(choice[default]) {
              background-color: transparent;
              opacity: 0.75;
              }
              ::slotted(choice[selected]) {
              background-color: #fff;
              text-decoration: underline;
              }
            .selected-option {
              font-size: 14px;
            }   
                    
            @media screen and (min-width: 750px) {
              ::slotted(choice), .selected-option {
                  font-size: 16px;
              }
            }
             
            `;

      wrapper.innerHTML = `
              <style>
                  ${styles}
              </style>
  
              <div class="custom-select">
               <span class="selected-option">${this.placeholder}</span>
                 <span class="arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
                    <path d="M16.2959 1.84424L8.70312 8.35233L1.11035 1.84424" stroke="black" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                </span>
              </div>
              <div class="custom-select-options">
                <slot></slot>
              </div>
            `;

      this.shadowRoot.appendChild(wrapper);
      this.select = this.shadowRoot.querySelector(".custom-select");
      this.optionsSlot = this.shadowRoot.querySelector("slot");
      this.optionsWrapper = this.shadowRoot.querySelector(
        ".custom-select-options"
      );
      this.selectedOption = this.shadowRoot.querySelector(".selected-option");

      this.optionsSlot.addEventListener("slotchange", () => {
        this.options = this.optionsSlot.assignedElements();
      });

      this.toggleOpen = this.toggleOpen.bind(this);
      this.handleOptionSlotClick = this.handleOptionSlotClick.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    toggleOpen() {
      this.hasAttribute("open")
        ? this.removeAttribute("open")
        : this.setAttribute("open", "");
    }

    handleClickOutside(e) {
      if (!this.contains(e.target)) {
        this.removeAttribute("open");
      }
    }

    selectOption(option) {
      this.setAttribute("value", option.textContent);
      this.options.forEach((opt) => opt.removeAttribute("selected"));
      option.setAttribute("selected", "");
      this.selectedOption.innerText = option.textContent;
      this.removeAttribute("open");
    }

    handleOptionSlotClick(e) {
      if (e.target.tagName !== "CHOICE") return;
      e.target.hasAttribute("default")
        ? this.removeAttribute("open")
        : this.selectOption(e.target);
    }

    unbindListeners() {
      this.select.removeEventListener("click", this.toggleOpen);
      this.optionsSlot.removeEventListener("click", this.handleOptionSlotClick);
      document.removeEventListener("click", this.handleClickOutside);
    }

    bindListeners() {
      this.select.addEventListener("click", this.toggleOpen);
      this.optionsSlot.addEventListener("click", this.handleOptionSlotClick);
      document.addEventListener("click", this.handleClickOutside);
    }

    connectedCallback() {
      this.bindListeners();
    }

    disconnectedCallback() {
      this.unbindListeners();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "value") {
        this.selectedValue = newValue;
      }
    }
  }

  if (!customElements.get("custom-select")) {
    customElements.define("custom-select", CustomSelect);
  }
})();
